<template>
    <div
        ref="root"
        class="
            flex
            items-center
            gap-4
            bg-gray-100
            py-2
            px-4
            rounded-lg
            relative
        "
        v-bind="$attrs"
        @click="selectRef.click()"
    >
        <div v-if="prefix">
            {{ prefix }}
        </div>
        <div>{{ options[modelValue] }}</div>
        <ion-icon
            name="chevron-down-outline"
            class="text-xl ml-auto"
        ></ion-icon>
        <select
            @change="tryAutosubmit"
            ref="selectRef"
            class="opacity-0 absolute top-0 left-0 w-full h-full"
            :name="name"
            v-model="localValue"
        >
            <option
                v-for="key in sortedOptions"
                :value="key"
                :key="key"
                :disabled="enableMaps ? !enableMaps.includes(key) : false"
            >
                {{ options[key] }}
            </option>
        </select>
    </div>
</template>

<script setup>
import { computed, onMounted, ref } from "vue";

const selectRef = ref(null);
const props = defineProps({
    name: String,
    options: Object,
    modelValue: String,
    prefix: String,
    autosubmit: Boolean,
    sortMap: Object,
    enableMaps: Array,
});

const localValue = computed({
    get() {
        return props.modelValue;
    },
    set(value) {
        emit("update:modelValue", value);
    },
});

const emit = defineEmits(["update:modelValue"]);

function tryAutosubmit() {
    if (props.autosubmit && selectRef.value.form) {
        selectRef.value.form.submit();
    } else {
        // emit("update:modelValue", selectRef.value.value);
    }
}

const sortedOptions = computed(() => {
    if (props.sortMap) {
        return Object.keys(props.sortMap).sort((a, b) => {
            return props.sortMap[a] - props.sortMap[b];
        });
    } else {
        return Object.keys(props.options);
    }
});
</script>

<style scoped></style>
